import Vue from 'vue';
import Component from 'vue-class-component';
import { LoyaltyCertStore } from '@/store/modules/Loyalty/Cert/LoyaltyCert';
import { ILoyaltyCert, ILoyaltyCertListItem } from '@/entity/loyalty/loyaltyCert/loyaltyCert/loyaltyCert.types';

@Component
export class LoyaltyCertMix extends Vue {
    get loyaltyCerts(): ILoyaltyCert | null {
        return LoyaltyCertStore.loyaltyCerts;
    }
    get loyaltyCert(): ILoyaltyCertListItem | null {
        return LoyaltyCertStore.loyaltyCert;
    }
    get itemsLoaded(): boolean {
      return LoyaltyCertStore.loyaltyCertLoaded;
    }
}
